import React from 'react';

const SprintMetricsStripSimple = ({ metrics, items = [], sprint, className = '' }) => {
  const safeItems = Array.isArray(items) ? items : [];
  const now = new Date();

  // Derive values from metrics, but fall back to computing from items when missing/zero
  const metricsCompletion = Number(metrics?.completionPct) || 0;
  const metricsTotal = Number(metrics?.totalItems) || 0;
  const metricsCompleted = Number(metrics?.completedItems) || 0;
  const metricsOverdue = Number(metrics?.overdueCount) || 0;
  const metricsBlocked = Number(metrics?.blockedCount) || 0;

  const derivedTotal = safeItems.length;
  const derivedCompleted = safeItems.filter((it) => String(it.status).toLowerCase() === 'completed').length;
  const derivedOverdue = safeItems.filter((it) => it.dueAt && new Date(it.dueAt) < now && String(it.status).toLowerCase() !== 'completed').length;
  const derivedBlocked = safeItems.filter((it) => String(it.status).toLowerCase() === 'blocked').length;

  const totalItems = metricsTotal > 0 ? metricsTotal : derivedTotal;
  const completedItems = metricsCompleted > 0 || totalItems === 0 ? metricsCompleted : derivedCompleted;
  const overdueCount = metricsOverdue > 0 ? metricsOverdue : derivedOverdue;
  const blockedCount = metricsBlocked > 0 ? metricsBlocked : derivedBlocked;
  const completionPct = totalItems > 0 ? Math.round((completedItems / totalItems) * 100) : metricsCompletion;

  const hasIssues = (overdueCount || 0) > 0 || (blockedCount || 0) > 0;

  // Days left calculation based on sprint end date
  let daysLeft = null;
  try {
    if (sprint && sprint.endOn) {
      const end = new Date(sprint.endOn);
      const msPerDay = 24 * 60 * 60 * 1000;
      const diff = Math.ceil((end.setHours(23,59,59,999) - now) / msPerDay);
      daysLeft = Math.max(0, diff);
    }
  } catch (_) {
    daysLeft = null;
  }

  return (
    <div className={`bg-succession-bg-secondary border-b border-succession-border ${className}`}>
      <div className="px-6 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-6">
            <div className="flex items-center gap-3">
              <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-green-100 text-green-700 text-xs">✓</span>
              <div>
                <span className="text-lg font-semibold text-succession-text-primary">
                  {completedItems} of {totalItems} done
                </span>
                <div className="w-32 mt-1">
                  <div className="h-2 w-full bg-succession-bg-tertiary rounded-full">
                    <div className="h-2 bg-succession-primary rounded-full" style={{ width: `${completionPct}%` }} />
                  </div>
                </div>
              {daysLeft !== null && (
                <div className="mt-1 text-xs text-succession-text-secondary">{daysLeft} {daysLeft === 1 ? 'day' : 'days'} left</div>
              )}
              </div>
            </div>
          </div>
          {hasIssues ? (
            <div className="flex items-center gap-4">
              {overdueCount > 0 && (
                <div className="flex items-center gap-2 text-orange-600 text-sm">
                  <span className="inline-block w-2 h-2 rounded-full bg-orange-500" />
                  <span className="font-medium">{overdueCount} overdue</span>
                </div>
              )}
              {blockedCount > 0 && (
                <div className="flex items-center gap-2 text-red-600 text-sm">
                  <span className="inline-block w-2 h-2 rounded-full bg-red-500" />
                  <span className="font-medium">{blockedCount} blocked</span>
                </div>
              )}
            </div>
          ) : (
            <div className="flex items-center gap-2 text-green-600 text-sm">
              <span className="inline-block w-2 h-2 rounded-full bg-green-500" />
              <span className="font-medium">All tasks on track</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SprintMetricsStripSimple;


